
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


const initialState = {
    type: '',
    text: '',
    order: '',
};
const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setType: (state, action) => {
            state.type = action.payload
        },
        setText: (state, action) => {
            state.text = action.payload
        },
        setOrder: (state, action) => {
            state.order = action.payload
        }
    },

});

export const { setType, setText, setOrder } = filterSlice.actions;
export default filterSlice.reducer